import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const NumeroDocumentoFormGroup = ({ innerRef, iTouched, iError, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-importe', e)
  }, [])

  React.useRef(() => {
    if (innerRef.current) {
      innerRef.current.focus()
    }
  }, [innerRef])

  return (
    <Form.Group>
      <Form.Label text='N° DOC' htmlFor='input-numeroDocumento' md={12} />
      <Col md={12}>
        <Field name='numeroDocumento'>
          {({ field }) => (
            <Form.InputText
              {...field}
              ref={innerRef}
              id='input-numeroDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
              autoFocus
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
